import React from "react";
import ReactDOM from "react-dom/client";
// import * as serviceWorkerRegistration from './serviceWorkerRegistration'; // Importar el archivo de configuración del service worker
import reportWebVitals from "./reportWebVitals";
import App from "./App";
import "./index.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);

// Registrar el service worker y manejar la actualización
// serviceWorkerRegistration.register({
//     onUpdate: (registration) => {
//         if (registration && registration.waiting) {
//             // Notificar al usuario o forzar la actualización
//             registration.waiting.postMessage({ type: 'SKIP_WAITING' });
//             window.location.reload();
//         }
//     },
// });

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
